import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";

export const fetchPosts = async (user, page, limit, startDate, endDate, type, search) => {
  let typevalue = `&type=${type}`
  let searchvalue = `&value=${search}`
  let url = `/posts/list?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}${type !== 'all' ? typevalue : ''}${search !== '' ? searchvalue : ''}`
  try {
    const { data } = await axios.get(`${API_BASE_URL}${url}`, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}

export const fetchPost = async (user, id) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/posts/${id}`, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}

export const archivePost = async (user, id) => {
  try {
    const { data } = await axios.delete(`${API_BASE_URL}/posts/${id}`, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}

export const unpinPost = async (user, id) => {
  try {
    const { data } = await axios.delete(`${API_BASE_URL}/posts/pin/${id}`, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}

export const pinPost = async (user, id) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/posts/pin/${id}`, {}, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}


export const deleteComment = async ({ user, post_uuid, comment_uuid }) => {
  try {
    const { data } = await axios.delete(`${API_BASE_URL}/posts/${post_uuid}/comment/${comment_uuid}`, buildHeaders(user));
    return data
  } catch (err) {
    throw err
  }
}

export const createPost = async (user, post) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/posts`, post, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}

export const updatePost = async (user, id, post) => {
  try {
    const { data } = await axios.put(`${API_BASE_URL}/posts/${id}`, post, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}

export const uploadPostImage = async (user, picture) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/posts/image`, { picture }, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}

export const fetchLastUserPosts = async (user, user_uuid, limit) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/posts/user?user_uuid=${user_uuid}${limit ? `&limit=${limit}` : ''}`, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}

export const fetchParadoxPosts = async (user, page, limit, startDate, endDate, type, search) => {
  let typevalue = `&type=${type}`
  let searchvalue = `&value=${search}`
  let url = `/posts/paradox/list?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}${type !== 'all' ? typevalue : ''}${search !== '' ? searchvalue : ''}`
  try {
    const { data } = await axios.get(`${API_BASE_URL}${url}`, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}

export const fetchParadoxPost = async (user, id) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/posts/paradox/${id}`, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}


export const archiveParadoxPost = async (user, id) => {
  try {
    const { data } = await axios.delete(`${API_BASE_URL}/posts/paradox/${id}`, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}

export const unpinParadoxPost = async (user, id) => {
  try {
    const { data } = await axios.delete(`${API_BASE_URL}/posts/paradox/pin/${id}`, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}

export const pinParadoxPost = async (user, id) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/posts/paradox/pin/${id}`, {}, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}


export const deleteParadoxComment = async ({ user, post_uuid, comment_uuid }) => {
  try {
    const { data } = await axios.delete(`${API_BASE_URL}/posts/paradox/${post_uuid}/comment/${comment_uuid}`, buildHeaders(user));
    return data
  } catch (err) {
    throw err
  }
}
